// Dynamically import a specific MDX file
export async function importMdx(locale, path) {
  try {
    const module = await import( /* webpackChunkName: "[request]" */
    `./${locale}/${path}.mdx`);
    return module;
  } catch (error) {
    console.error('Failed to load MDX file:', locale, path, error);
    return null;
  }
}